import { fetchJson } from '@atlassian/jira-fetch';
import type { CloudId } from '@atlassian/jira-shared-types';

export const getLinkedOrg = (cloudId: CloudId) =>
	fetchJson(`/gateway/api/adminhub/sites/${cloudId}/linked-org`, {
		method: 'GET',
	});
